<form
  class="bn-dialog {{ data?.textCenter ? 'bn-dialog--text-center' : '' }}"
  [formGroup]="form"
  (ngSubmit)="onSubmit()">
  <div class="bn-dialog__icon bn-dialog__icon--{{ data?.contextType }}">
    @if (data?.gradientIcon) {
      <fa-icon
        class="gradientIcon"
        [icon]="data?.icon ?? 'circle-question'"
        [ngClass]="data?.contextType ? 'gradient-' + data?.contextType : ''" />
    } @else {
      <fa-duotone-icon
        size="2x"
        [icon]="data?.icon ?? 'circle-exclamation'" />
    }
  </div>
  <div class="bn-dialog__title">{{ data?.title }}</div>
  <div class="bn-dialog__body">
    @if (data?.name) {
      <div class="py-2">
        <strong>{{ data?.name }}</strong>
      </div>
    }
    <div [innerHtml]="data?.description | sanitizeHtml: ['p', 'br', 'span', 'strong', 'b', 'em', 'i', 'u'] : ['class']"></div>
    <div class="text-start">
      <bn-web-ui-input
        class="d-block mt-3"
        formControlName="inputControl"
        [inputName]="inputSettings?.inputName"
        [label]="data?.input?.label"
        [max]="data?.input?.max ?? null"
        [maxlength]="data?.input?.maxlength ?? null"
        [min]="data?.input?.min ?? null"
        [placeholder]="data?.input?.placeholder"
        [size]="data?.input?.size || 'md'"
        [type]="data?.input?.type || 'text'" />
      @if (errorMessage) {
        <bn-web-ui-formcontrol-errors [customError]="errorMessage" />
      }
    </div>
    @if (data?.checkbox) {
      <div class="mt-3">
        <bn-web-ui-checkbox
          [label]="data?.checkbox?.label"
          [ngModelOptions]="{ standalone: true }"
          [(ngModel)]="checkboxChecked" />
      </div>
    }
  </div>
  <div class="bn-dialog__actions row g-2">
    <div class="col-6 mt-0">
      <button
        bn-web-ui-button
        size="lg"
        type="submit"
        [disabled]="form.invalid"
        [fullWidth]="true"
        [itemStyle]="data?.contextType === 'danger' ? 'danger' : 'primary'"
        [loading]="isLoading()">
        {{ data?.confirmButtonName }}
      </button>
    </div>
    <div class="col-6 mt-0">
      <button
        bn-web-ui-button
        itemStyle="stroke"
        size="lg"
        type="button"
        [fullWidth]="true"
        (click)="onCloseDialog()">
        {{ data?.closeButtonName || 'Cancel' }}
      </button>
    </div>
  </div>
</form>
